import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { APIProvider } from './utils/api'
import { GlobalProvider } from './utils/globalState'
import { BrowserRouter as Router } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import './styles/index.css'

const rootContent = (
	<HelmetProvider>
		<APIProvider>
			<GlobalProvider>
				<Router>
					<App />
				</Router>
			</GlobalProvider>
		</APIProvider>
	</HelmetProvider>
)

ReactDOM.render(rootContent, document.getElementById('root'))
